import styles from './index.module.css';
const ParallaxLayout = ({children,reverse,parallax = true}) => {
    return (
        <div className={`${styles.ctn} ${reverse ? styles.reverse : ''} ${!parallax ? styles.noParallax : ''}`}>
            {
                children
            }
        </div>
    )
}

export default ParallaxLayout